import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_URL || "/_api";

console.log('[apiClient] Initialized with baseURL:', `${API_BASE_URL}/api/v1`);

export const apiClient = axios.create({
  baseURL: `${API_BASE_URL}/api/v1`,
  headers: {
    "Content-Type": "application/json",
  },
  paramsSerializer: (params) => {
    const sp = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (Array.isArray(v)) v.forEach((item) => sp.append(k, String(item)));
      else if (v !== undefined && v !== null) sp.append(k, String(v));
    }
    return sp.toString();
  },
});

// Add auth token to requests
apiClient.interceptors.request.use(
  (config) => {
    // Axios treats URLs starting with / as absolute paths, ignoring baseURL.
    // Strip the leading slash to make them relative to baseURL.
    if (
      config.baseURL &&
      typeof config.url === "string" &&
      config.url.startsWith("/")
    ) {
      config.url = config.url.substring(1);
    }

    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Handle 401 responses + surface FastAPI `detail` as error.message so UIs that
// render error.message get a useful string instead of "Request failed with status code 409".
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // A 401 from the login endpoint itself means "wrong credentials" — let the
    // Login page render the error. Don't clear tokens or force a reload, which
    // would wipe out other sessions and make the error flash and vanish.
    const requestUrl: string = error.config?.url ?? "";
    const isLoginRequest = requestUrl.includes("/auth/login");
    if (error.response?.status === 401 && !isLoginRequest) {
      localStorage.removeItem("access_token");
      window.location.href = "/login";
    }
    const detail = error.response?.data?.detail;
    if (typeof detail === "string") {
      error.message = detail;
    } else if (
      detail
      && typeof detail === "object"
      && typeof (detail as { message?: unknown }).message === "string"
    ) {
      error.message = (detail as { message: string }).message;
    } else if (Array.isArray(detail)) {
      // Pydantic validation errors come back as an array of {msg, loc, ...}.
      // Custom validators arrive prefixed with "Value error, " — strip it so
      // non-technical users see the plain German sentence.
      error.message = detail
        .map((e: { msg?: string }) => e.msg?.replace(/^Value error, /, ""))
        .filter(Boolean)
        .join("; ");
    }
    return Promise.reject(error);
  },
);
